/**
 * Makes a request to the specified URL and returns the JSON response.
 *
 * @param url - The URL to make the request to.
 * @param options - The options for the request.
 * @returns The JSON response.
 * @throws An error if the request fails.
 */
export async function makeRequest<T>(
	url: string,
	options: RequestInit,
): Promise<T> {
	const response = await fetch(url, options);
	if (!response.ok) {
		throw new Error(`Failed to fetch: ${response.statusText}`);
	}
	return response.json() as T;
}
